import { useContext } from "react";
import { BadgeCheck, ShieldCheck } from "lucide-react";
import Header from "../component/header";
import Footer from "../component/Footer";
import Banner from "../component/Banner";
import BannerImg from "../image/gallaryBanner.png";
import { UserDataContext } from "../context/User";

const Badges = () => {
  const { userData } = useContext(UserDataContext);
  const badges = userData?.badges || [];

  return (
    <div>
      <Header />
      <Banner backgroundImage={BannerImg} heading="My Badges" minHeight="40vh" padding="80px 0" />

      <section className="main-lwbl bg-[#F9FAFB] py-16 px-4 rounded-[30px]">
        <div className="max-w-4xl mx-auto">

          <div className="text-center mb-10">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-400 to-blue-500 flex items-center justify-center mx-auto mb-4 shadow-md">
              <BadgeCheck size={28} className="text-white" strokeWidth={1.5} />
            </div>
            <h2 className="font-cinzel text-3xl font-bold text-gray-900 mb-2">My Badges</h2>
            <p className="font-outfit text-gray-500">
              Badges earned through participation, achievements, and milestones.
            </p>
          </div>

          {badges.length === 0 ? (
            <div className="text-center py-20 bg-white rounded-3xl border border-gray-100 shadow-sm">
              <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mx-auto mb-4">
                <ShieldCheck size={30} className="text-gray-300" strokeWidth={1.5} />
              </div>
              <h3 className="font-cinzel text-xl font-bold text-gray-700 mb-2">No Badges Yet</h3>
              <p className="font-outfit text-gray-400 text-sm max-w-sm mx-auto">
                Complete quests, submit projects, and engage with the community to earn your first badge.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
              {badges.map((badge) => (
                <div
                  key={badge.id || badge._id}
                  className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 text-center hover:shadow-md hover:-translate-y-1 transition-all duration-200"
                >
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-400 to-blue-500 flex items-center justify-center mx-auto mb-3 shadow">
                    {badge.icon ? (
                      <img src={badge.icon} alt={badge.name} className="w-8 h-8 object-contain" />
                    ) : (
                      <BadgeCheck size={26} className="text-white" strokeWidth={1.5} />
                    )}
                  </div>
                  <h4 className="font-cinzel font-bold text-gray-900 text-sm">{badge.name}</h4>
                </div>
              ))}
            </div>
          )}

        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Badges;
